<div class="custom-select">
  <input
    class="selected-option"
    [ngClass]="{ 'selected-option': true, opened: isDropdownOpen }"
    (mousedown)="$event.preventDefault()"
    (click)="toggleDropdown()"
    [readonly]="true"
    [value]="getSelectedOptionText()"
  />
  <span class="custom-select__icon" aria-hidden="true"></span>
  @if (isDropdownOpen) {
    <ul class="dropdown-list">
      @for (option of options; track option; let i = $index) {
        <li (click)="selectOption(option)">
          <div class="text-box">
            <div class="text">{{ option.text }}</div>
            @if (value === option.value) {
              <i class="icon-ok-2"></i>
            }
          </div>
        </li>
      }
    </ul>
  }
</div>
